import React, {useEffect, useState} from "react";
import {Divider, Space, Spin} from "antd";
import {NewsApi} from "../../services/NewsApi";
import {useNavigate} from "react-router-dom";
import NewsListCell from "../../containers/news/NewsListCell";

const NewsDashboardList = () => {
    const nav = useNavigate()

    const [loading, setLoading] = useState(true)
    const [news, setNews] = useState([])

    useEffect(() => {
        NewsApi.list(0, 20, null, "13", null)
            .onSuccess(data => {
                setNews([...data])
            })
            .onComplete(() => setLoading(false))
    }, []);

    const handleNewsClick = (sid) => {
        nav('/news?sid=' + sid)
    }

    return (
        <>
            <Spin spinning={loading}>
                <Space direction={'vertical'} split={<Divider style={{margin: '0'}}/>}>
                    {
                        news.map(n =>
                            <NewsListCell
                                news={n}
                                onClick={() => handleNewsClick(n.sid)}
                            />
                        )
                    }
                </Space>
            </Spin>
        </>
    )
}

export default NewsDashboardList